export const releaseInfo = {
    version: '85a6985d',
}
